var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455.1 187"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ValHouse_svg__all"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__house3",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M743.8 612H629.7h0V479.9l56.1-51 56.1 51v130.6",
    transform: "matrix(1.00495 0 0 1 -405.278 -426.9)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ValHouse_svg__house3Features"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__door",
    fill: "#fff",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M773.8 555.2h72.3v55.4h-72.3z",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__line288",
    fill: "#f7f6f2",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M793.7 555.2v54.6",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__window",
    fill: "#fff",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M782.1 490.9h55.4v27.4h-55.4z",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__path398",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.9,
    d: "M830 499.2h-4.6s-7.4-.4-10 6c0 0-3.2 4.4-7.6 4.6 0 0-7.3-.2-7.9 4.3",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__line506",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.9,
    d: "M834.8 574.8l-19.3 19.3",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__line508",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.9,
    d: "M833.2 564.2l-19.3 19.3",
    transform: "matrix(1.00495 0 0 1 -531.5 -426.2)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__house2",
    fill: "#fff",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M743.8 612H629.7h0V479.9l56.1-51 56.1 51v130.6",
    transform: "matrix(1.00495 0 0 1 -518.034 -426.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__house1",
    fill: "#fff",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M743.8 612H629.7h0V479.9l56.1-51 56.1 51v130.6",
    transform: "matrix(1.00495 0 0 1 -630.79 -426.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValHouse_svg__house4",
    fill: "#fff",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M743.8 612H629.7h0V479.9l56.1-51 56.1 51v130.6",
    transform: "matrix(1.00495 0 0 1 -292.523 -426.9)"
  }))));
}
export default SvgValHouse;